import {useEffect, useState} from 'react';
import {InputGroupsData} from '../utilities/inputGroups';

const useSetInputGroups = () => {
  const [inputGroups, setInputGroups] =
    useState<IInputGroup[]>(InputGroupsData);
  const [selectedInputGroups, setSelectedInputGroups] = useState<string>('');
  const handleSelectInputGroup = (id: number) => {
    const newInputGroups = [...inputGroups];
    const findSelectedInputGroup = newInputGroups.find(item => item.id === id);
    if (findSelectedInputGroup) {
      const filtredInputGroups = newInputGroups.filter(item => item.id !== id);
      setInputGroups([
        ...filtredInputGroups,
        {
          ...findSelectedInputGroup,
          isSelected: !findSelectedInputGroup.isSelected,
        },
      ]);
    }
  };
  useEffect(() => {
    const filtredInputGroups = inputGroups.filter(
      item => item.isSelected === true,
    );
    const selectedInputGroupsCode: number[] = [];
    filtredInputGroups.map(item => selectedInputGroupsCode.push(item.code));
    setSelectedInputGroups(selectedInputGroupsCode.toString());
  }, [inputGroups]);
  return {handleSelectInputGroup, inputGroups, selectedInputGroups};
};

export default useSetInputGroups;
